import { useState } from 'react';
import api from '../lib/api';

export default function QuickAddContact({ onAdd, onClose, defaultCompanyId }) {
  const [form, setForm] = useState({
    first_name:'', last_name:'', email:'', phone:'', title:'',
    company_id: defaultCompanyId || ''
  });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async () => {
    setError('');
    if (!form.first_name.trim()) return setError('First name is required.');
    if (!form.last_name.trim()) return setError('Last name is required.');
    setSaving(true);
    try {
      const r = await api.post('/contacts', {
        ...form,
        company_id: form.company_id || null,
        status: 'lead',
        source: 'manual',
      });
      onAdd(r.data.contact);
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to create contact.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{
      position:'fixed', top:0, left:0, right:0, bottom:0,
      background:'rgba(0,0,0,0.4)', zIndex:2000,
      display:'flex', alignItems:'center', justifyContent:'center'
    }}>
      <div style={{
        background:'var(--bg)', borderRadius:'var(--radius-lg)',
        padding:24, width:480, maxWidth:'90vw',
        border:'0.5px solid var(--border-md)',
        boxShadow:'0 16px 48px rgba(0,0,0,0.2)'
      }}>
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
          <div style={{ fontSize:15, fontWeight:600 }}>Add new contact</div>
          <button onClick={onClose} style={{ background:'none', border:'none', cursor:'pointer',
                                              color:'var(--text-tertiary)', fontSize:18 }}>✕</button>
        </div>

        <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10 }}>
          <div>
            <label className="form-label">First name *</label>
            <input className="form-input" value={form.first_name}
              onChange={e => setForm({...form, first_name:e.target.value})}
              placeholder="First name" autoFocus />
          </div>
          <div>
            <label className="form-label">Last name *</label>
            <input className="form-input" value={form.last_name}
              onChange={e => setForm({...form, last_name:e.target.value})}
              placeholder="Last name" />
          </div>
          <div>
            <label className="form-label">Email</label>
            <input className="form-input" type="email" value={form.email}
              onChange={e => setForm({...form, email:e.target.value})}
              placeholder="email@company.com" />
          </div>
          <div>
            <label className="form-label">Phone</label>
            <input className="form-input" value={form.phone}
              onChange={e => setForm({...form, phone:e.target.value})}
              placeholder="555-123-4567" />
          </div>
          <div>
            <label className="form-label">Title</label>
            <input className="form-input" value={form.title}
              onChange={e => setForm({...form, title:e.target.value})}
              placeholder="e.g. Purchasing Manager" />
          </div>
        </div>

        {error && <div className="form-error" style={{ marginTop:8 }}>{error}</div>}

        <div style={{ display:'flex', gap:8, marginTop:16 }}>
          <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Saving…' : 'Create contact'}
          </button>
          <button className="btn" onClick={onClose}>Cancel</button>
        </div>
      </div>
    </div>
  );
}